import React, {Component} from 'react';

import {
	Modal, Loader
} from 'rsuite';
import { Image } from 'react-bootstrap';
import i18n from '../i18n';

class ModalLoader extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			title:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentDidUmount(){
		this.props.onRef(null);
	}

	handleShow(title, message, name = null){
		this.setState({
			show:true,
			// Algunas llamadas (p. ej. Home.js) muestran el modal sin pasarle
			// mensaje — se usa un genérico en vez de quedar en blanco.
			title: title || i18n.t('modal.spin.loading'),
		});
	}

	handleClose(){
		this.setState({show:false});
	}

	render(){
		return (
			<Modal className="modal-loader" backdropClassName="modal-loader-backdrop" show={this.state.show} onHide={this.handleClose} size="xs">
				<Modal.Body>
					<div className="modal-loader-body">
						<Image src="images/image.png" alt="JustCheck" className="modal-loader-logo" />
						<Loader size="lg" content={this.state.title} vertical />
					</div>
				</Modal.Body>
			</Modal>
		);
	}

}

export default ModalLoader;